/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    title: {
        ...theme.custom.apiOverviewPage.tabs.overview.apiScopesTitleBox
    },
    titleHead: {
        ...theme.custom.apiOverviewPage.tabs.overview.apiScopesTitleText
    },
    grid: {
        ...theme.custom.apiOverviewPage.tabs.overview.scopesGrid
    },
    customDenseListItem: {
        marginLeft: theme.spacing(1),
        marginTop: -theme.spacing(1),
        '& .MuiListItem-dense': {
            paddingTop: 0,
            paddingBottom: 0,
        },
        '& .MuiListItem-gutters': {
            paddingLeft: theme.spacing(0.5),
            paddingRight: 0,
        },
    },
    indentedSkeleton: {
        marginLeft: theme.spacing(1),
    },
    skeletonSpacer: {
        marginTop: theme.spacing(1),
    },
    smallText: {
        fontSize: '12px',
    },
    boldText: {
        fontWeight: 'bold',
        fontSize: '12px',
    },
    customAccordionSummaryContent: {
        '& .MuiAccordionSummary-content': {
            margin: 0,
            flexGrow: 0,
        },
        '& .MuiIconButton-root': {
            padding: theme.spacing(0.5),
        },
    },
    customAccordionSummaryRoot: {
        '& .MuiAccordionSummary-root': {
            minHeight: 'auto',
            justifyContent: 'flex-start',
        },
        border: 'none',
        boxShadow: 'none',
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: 0,
        },
    },
    customAccordionDetails: {
        '& .MuiAccordionDetails-root': {
            paddingTop: 0,
            paddingLeft: theme.spacing(3),
            paddingBottom: theme.spacing(0),
        },
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
}));

export default useStyles;
